import React from 'react'
import quote from '../images/quotes.png'
import vc from './vc_mam.jpg'
import zahid_sir from './Zahid-Raza.jpg'
import lobiyal_sir from './lobiyal_sir.jpg'
import Yadav_sir from './Yadav_sir.jpg'
import Hoda_sir from './hoda_sir.jpg'
import ansari_sir from './ansari_sir.jpg'
import karan_sir from './karan_sir.jpg'
import Brajesh_sir from './Brajesh_sir.jpg'
import Ahamd_sir from './K_A_Ahmd_sir.jpg'
import Sushil_sir from './Sushil_sir.jpg'
import bhavnesh_sir from './Bhavnesh_sir.jpg'
import Sergy_sir from './Sergey_sir.jpg'
import Ashok_sir from './ashok_sir.jpg'
import sanidhya_sir from './sanidhya_sir.jpg'
import doja_sir from './doja_sir.jpg'
import sanjay_sir from './sanjay_sir.jpg'
import sudhansu_sir from './sudhansu_sir.jpg'
import rajeev_sir from './rajeev_sir.jpg'
import gadadhar_sir from './gadadhar_sir.jpg'
import fabrizo_sir from './fabrizo_sir.jpg'
import sudhir_sir from './sudhir_sir.jpg'
import minz_mam from './minz_mam.jpg'
import pandiyan_sir from "./pandiyan_sir.jpg"
import alam_sir from './alam_sir.jpg'
import satish_sir from './satish_sir.jpg'
import rahul_sir from './rahul_sir.jpg'
import vivek_sir from './vivek_sir.jpg'
import shariq_sir from './shariq_sir.jpg'
import gupteshwar_sir from './Gupteswar_sir.jpg' 

import './testimony.css'

function Testimony() {

  const Testimony=[
    {
        Name:"Prof. Santishree D Pandit",
        position:"Vice-chancellor",
        place:"Jawaharlal Nehru University, New Delhi, India",
        message: "The NETCRYPT was a pioneering platform that brought together the brightest minds in cyber security, cryptography, and network security.",
        image:vc
    },

    // {
    //     Name:"Prof. Brajesh Kumar Pandey",
    //     position:"Rector-I",
    //     place:"Jawaharlal Nehru University, New Delhi, India",
    //     message: "In an era where digital security is paramount, the NETCRYPT emerged as a crucial forum for thought leadership, research excellence, and technological advancement.",
    //     image:Brajesh_sir
    // },

    {
        Name:"Prof. Zahid Raza",
        position:"",
        place:"Jawaharlal Nehru University, New Delhi, India",
        message: "Cybersecurity is no longer a choice but a necessity in our interconnected world, and the NETCRYPT was a testament to our collective commitment to securing the digital frontier.",
        image:zahid_sir
    },

    {
        Name:"Prof. D. K. Lobiyal",
        position:"",
        place:"Jawaharlal Nehru University, New Delhi, India",
        message: "The NETCRYPT, represented a unique opportunity to explore the latest advancements, challenges, and innovations in cryptography and network security.",
        image:lobiyal_sir
    },

    {
        Name:"Prof. R. S. Yadav",
        position:"",
        place:"MNNIT, Prayagraj, UP, India",
        message: "I extend my heartfelt blessings and best wishes to NETCRYPT. May this gathering foster groundbreaking discussions, innovative ideas, and enduring collaborations in the fields of networks and cryptology.",
        image: Yadav_sir
    },

    {
        Name:"Prof. Khairol Amali Bin Ahmad",
        position:"",
        place:"National Defence University of Malasysia, Malasysia",
        message: "May this conference be a platform for vibrant discussions, groundbreaking ideas, and fruitful collaborations in the ever-evolving fields of networks and cryptology.",
        image: Ahamd_sir
    },

    {
        Name:"Prof. Sergey Bezzateev",
        position:"",
        place:"ITMO University, St. Petersburg, Russia",
        message: "May this distinguished conference NETCRYPT at Jawaharlal Nehru University, New Delhi, ignite pioneering discoveries, nurture profound connections, and chart new horizons in networks and cryptology.",
        image: Sergy_sir
    },

    

    {
        Name:"Prof. M. N. Hoda",
        position:"Director",
        place:"BVICAM, New Delhi, India",
        message: "The NETCRYPT-2025 was an extraordinary experience, bringing together global experts to discuss the latest frontiers in cryptology and network security. The engaging sessions and diverse perspectives presented were truly inspiring.",
        image: Hoda_sir
    },

    {
        Name:"Prof. Abdul Q. Ansari",
        position:"Professor",
        place:"Jamia Millia Islamia, New Delhi, India",
        message: "The NETCRYPT-2025, a conference that brought together brilliant minds in networks and cryptology. The quality of research presented, the engaging discussions, and the seamless organization were truly commendable. ",
        image: ansari_sir
    },

    {
        Name:"Dr. Karan Singh",
        position:"",
        place:"Jawaharlal Nehru University, New Delhi, India",
        message: "This event was the culmination of months of dedication, collaboration, and vision, that brought together experts from academia, industry, and government to deliberate on the most pressing issues in cybersecurity.",
        image: karan_sir
    },

    {
        Name:"Dr. Bhavnesh Kumar",
        position:"",
        place:"NSUT, New Delhi, India",
        message: "In my role as Convener of the International Conference on Networks and Cryptology (NETCRYPT 2025), I offer my sincerest blessings and enthusiastic wishes for an exceptional conference.",
        image: bhavnesh_sir
    },

    {
        Name:"Dr. Sushil Kumar",
        position:"",
        place:"Jawaharlal Nehru University, New Delhi, India",
        message: "As the Conference Chair of the International Conference on Networks and Cryptology (NETCRYPT 2025), I extend my heartfelt blessings and best wishes for a dynamic and inspiring conference.",
        image: Sushil_sir
    },

    {
        Name:"Prof. Ashok Kumar Nagawat",
        position:"Vice Chancellor",
        place:"DSEU, New Delhi, India",
        message: "The International Conference on Networks and Cryptology (NETCRYPT-2025) was a landmark event that showcased the pinnacle of innovation in networks and cryptology.",
        image: Ashok_sir
    },

    
    {
        Name:"Prof. Somitra Kumar Sanadhya",
        position:"",
        place:"IIT Jodhpur, India",
        message: "The NETCRYPT-2025 was impeccably organized, with a perfect blend of theoretical insights and practical applications in networks and cryptology. The enthusiasm of the participants and the quality of discussions were outstanding.",
        image: sanidhya_sir
    },
    {
        Name:"Prof. M.N. Doja",
        position:"Former Director",
        place:"IIIT Sonepat, India",
        message: "I was confident that the ideas exchanged in NETCRYPT-2025 will lead to groundbreaking developments in secure communication and cryptography. I look forward to seeing this conference grow even further in the coming years.",
        image: doja_sir
    },

    {
        Name:"Prof. Sanjay Jasola",
        position:"Vice Chancellor",
        place:"DBS Global University in Dehradun, India",
        message: "The International Conference on Networks and Cryptology (NETCRYPT-2025) was a testament to JNU’s leadership in fostering global collaboration in cryptology and network security.",
        image: sanjay_sir
    },

    {
        Name:"Dr. Sudhanshu Aggarwal",
        position:"",
        place:"INSA, New Delhi, India",
        message: "The International Conference on Networks and Cryptology (NETCRYPT-2025) was an outstanding platform for exploring the future of secure networks and cryptology. The JNU delivered an event that was both visionary and flawlessly executed",
        image: sudhansu_sir
    },

    {
        Name:"Prof. Rajeev Tripathi",
        position:"Vice Chancellor",
        place:"Rajiv Gandhi Proudyogiki Vishwavidyalaya, Bhopal, Madhya Pradesh, India",
        message: "The NETCRYPT-2025 was an extraordinary event that highlighted the critical role of cryptology in today’s digital world. JNU created a platform that fostered meaningful dialogue and collaboration.",
        image: rajeev_sir
    },

    {
        Name:"Prof. Gadadhar Misra",
        position:"",
        place:"IIT Gandhinagar, India",
        message: "The NETCRYPT-2025 was a phenomenal event that showcased the forefront of research in network security and cryptology. Kudos to the organizing team for their flawless execution and for fostering an environment of innovation and collaboration.",
        image: gadadhar_sir
    },

    {
        Name:"Prof. Fabrizio Baiardi",
        position:"",
        place:"Universita' Di Pisa, Italy",
        message: "The NETCRYPT-2025 was a stellar platform for exploring the evolving landscape of cryptology and network security.The SC&SS at JNU has set a benchmark for academic conferences with its seamless execution and thought-provoking sessions",
        image: fabrizo_sir
    },

    {
        Name:"Dr. Sudhir Khare",
        position:"",
        place:"DRDO, Dehradun, India",
        message: "The NETCRYPT stood out for its comprehensive coverage of emerging trends in networks and cryptology, from quantum cryptography to secure communication protocols.",
        image: sudhir_sir
    },

    {
        Name:"Prof. Sonajharia Minz",
        position:"",
        place:"Jawaharlal Nehru University, India",
        message: "The NETCRYPT-2025 was a remarkable platform for discussing the intersection of cryptology and network technologies. The SC&SS at JNU deserves accolades for hosting such a well-executed and impactful event that will leave a lasting mark on the field.",
        image: minz_mam
    },

    {
        Name:"Dr. K. K. Soundra Pandian",
        position:"Scientist",
        place:"MeitY, New Delhi, India",
        message: "The NETCRYPT-2025 was a melting pot of innovative ideas, with discussions ranging from blockchain security to AI-driven cryptology. JNU’s meticulous planning and commitment to academic excellence made this event a standout.",
        image: pandiyan_sir
    },

    {
        Name:"Prof. Mansaf Alam",
        position:"",
        place:"Jamia Millia Islamia, New Delhi, India",
        message: "The panel discussions of NETCRYPT-2025 were dynamic and thought-provoking, addressing critical challenges in cyber security. JNU’s SC&SS has set a new standard for academic conferences.",
        image: alam_sir
    },

    {
        Name:"Prof. Satish Chand",
        position:"",
        place:"Jawaharlal Nehru University, India",
        message: "The panel discussions at the NETCRYPT-2025 were a testament to the conference’s commitment to fostering innovation in cryptology and network security. JNU has built a platform to inspire the next generation of researchers.",
        image: satish_sir
    },

    {
        Name:"Prof. Rahul Johari",
        position:"",
        place:"Guru Gobind Singh Indraprastha University, Delhi, India",
        message: "As a panelist in NETCRYPT-2025, I was impressed by the high caliber of discussions and the organizers’ ability to create a collaborative environment. JNU’s sC&SS has delivered an event that will be remembered as a turning point in the field.",
        image: rahul_sir
    },

    {
        Name:"Prof. Vivek Shrivastava",
        position:"",
        place:"NIT Uttarakhand, Srinagar, India",
        message: "The panel discussions at NETCRYPT-2025 were engaging and forward-looking, addressing the most pressing issues in network security and cryptology. JNU’s impeccable organization and focus on fostering global collaboration made this conference a resounding success.",
        image: vivek_sir
    },

    // {
    //     Name:"Dr. Mohammad Shariq",
    //     position:"",
    //     place:"UAE University, Al Ain, Abu Dhabi",
    //     message: "The NETCRYPT-2025 was an exceptional conference that brought together the brightest minds in cryptology and network security. Delivering a keynote at JNU was a highlight of my academic career.",
    //     image: shariq_sir
    // },

    // {
    //     Name:"Mr. Gupteswar Majhi",
    //     position:"",
    //     place:"C-DOT, Delhi, India",
    //     message: "The NETCRYPT-2025 was a brilliantly organized event that showcased the latest advancements in networks and cryptology. The panel discussions were a highlight, offering deep insights into the future of secure communications.",
    //     image: gupteshwar_sir
    // },
  ]
  return (
    <>
        <h1 className='text-center my-5 text-danger'> <strong>Testimonials</strong> </h1>

            <marquee loop="infinite" behavior="scroll" direction="left" scrollamount="10">
            

            {Testimony.map((e,index)=>(

                
                <div class="card testimony-card mb-3 d-inline-block mx-3 m-2 shadow" style={{maxWidth: "540px"}}>
                <div class="row g-0">
                    <div class="col-md-4">
                    <img src={e.image} class="img-fluid rounded-circle my-5 mx-3" alt="..." style={{maxWidth:"80%"}} />
                    </div>
                    <div class="col-md-8">
                    <div class="card-body d-flex flex-column">
                        <img src={quote} class="card-img-top" alt="..." style={{maxWidth:"10%"}}/>
                        <p class="card-text my-3" style={{whiteSpace:"normal", wordBreak:"break-word", textAlign:"justify"}}>{e.message}</p>
                        <p class="card-text"><small class="text-body-secondary" style={{whiteSpace:"normal", wordBreak:"break-word", textAlign:"justify"}}>{e.Name} <br/> {e.position} {e.position===""?"":","} {e.place} </small></p>
                        
                    </div>
                    </div>
                </div>
                </div>
            

            ))}
            
            </marquee>
            
    </>
  )
}

export default Testimony